<template>
  <div class="events">
    <el-form
      ref="form"
      style="margin-bottom: 0"
      :model="form"
      label-position="left"
      label-width="100px"
    >
      <template v-if="typeTask == 1">
        <el-form-item label="事项名称">
          <el-input
            v-model="form.sxmc"
            placeholder="请输入事项名称"
            style="width: 300px"
          ></el-input>
        </el-form-item>
      </template>
      <template v-if="typeTask == 2">
        <el-form-item label="事项名称">
          <el-input
            v-model="form.sxmc"
            placeholder="请输入事项名称"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="主办部门">
          <el-select
            filterable
            placeholder="请输入主办部门"
            clearable
            style="width: 300px"
            v-model="form.sxmc"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.sxlx"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡查清单">
          <el-button type="primary" @click="openDrawer({}, true)" class="el-icon-download"
            >模版下载</el-button
          >
          <el-button type="primary" @click="openDrawer({}, true)">批量上传</el-button>
        </el-form-item>
      </template>
    </el-form>

    <div class="index-list" v-if="typeTask == 1">
      <div class="title">
        <span style="margin-right: 14px">任务指标</span>
        <el-button type="text" @click="openDrawer({}, true)" class="el-icon-plus"
          >添加</el-button
        >
      </div>
      <div class="index" v-if="indexList.length">
        <div
          class="index-item"
          :class="{ active: curId == index }"
          v-for="(item, index) in indexList"
          :key="index"
          @click="curId = index"
        >
          <div>{{ item.zbmc }}</div>
          <div class="edit-btns" v-if="curId == index">
            <el-button
              type="text"
              @click="openDrawer(item, false, index)"
              style="color: #0090ff; font-size: 16px"
              class="el-icon-edit"
              >编辑</el-button
            >
            <el-button
              type="text"
              style="color: #eb3538; font-size: 16px"
              class="el-icon-delete"
              @click="delindexListFun(index)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <div class="empty" v-else>
        <div style="text-align: center">
          <img src="@/assets/image/empty.png" alt="" />
          <div>暂无数据</div>
          <div class="btns">
            点击<el-button type="text" @click="openDrawer({}, true)"
              >添加任务指标</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="table-list" v-if="typeTask == 2">
      <div class="table-top-btns">
        <div class="left-btn">
          <div class="select-number">
            当前选中
            <span style="color: #3666ea">{{ selectedIdOptions.length }}</span>
            条
          </div>
        </div>
      </div>
      <common-table
        :select="true"
        :isShowPagination="false"
        :dataList="dataList"
        :maxHeight="320"
        :selectedIdOptions="selectedIdOptions"
        @handleSelectionChange="handleSelectionChange"
        @selectAll="selectAll"
      >
      </common-table>
    </div>
    <indexDialog
      v-if="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
      @updateData="updateData"
    ></indexDialog>
  </div>
</template>

<script>
import commonTable from "@/components/table/index.vue";
import pageChangeSelect from "@/mixins/page-change-select.js";
import indexDialog from "./indexDialog";
import { eventPage, selList } from "@/api/base.js";
import { dictItemRoot } from "@/api/systemManagement.js";
export default {
  components: {
    commonTable,
    indexDialog,
  },
  mixins: [pageChangeSelect],
  props: {
    eventsInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    typeTask: {
      type: Number,
    },
  },
  data() {
    return {
      form: {
        sxmc: "",
      },
      searform: {
        ghEventTypeId: "",
        sfyjsx: "",
        zrrlx: "",
        sxmc: "",
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "ghEventTypeName",
            label: "姓名",
          },
          {
            prop: "sxmc",
            label: "所属社区",
          },
          {
            prop: "ghEventTypeSfyjsx",
            label: "年龄",
          },
          {
            prop: "zrrlx",
            label: "身份证号",
          },
          {
            prop: "zrrlx",
            label: "联系方式",
          },
          {
            prop: "zrrlx",
            label: "联系地址",
          },
        ],
      },
      indexList: [],
      curId: 0,
      dialogVisible: false,
      curItem: {},
      typeList: [],
      zrrlxOptions: [],
      isEmergency: false,
    };
  },
  async mounted() {
    this.selectedIdOptions = this.eventsInfo.selectedIdOptions || [];
    this.indexList = this.eventsInfo.indexList || [];
    this.form = JSON.parse(JSON.stringify(this.eventsInfo.eventInfo));

    // this.selListFun();
    // this.dictItemRootFun();
    // this.eventPageFun();
  },
  methods: {
    regionChange() {
      this.$emit("regionChange");
    },
    openDrawer(item, isAdd, index) {
      this.curItem = {
        ...item,
        isAdd,
        index,
      };
      this.dialogVisible = true;
    },
    updateData(item) {
      if (item.isAdd) this.indexList.unshift(item);
      else this.indexList[item.index] = { ...item };
    },
    delindexListFun(index) {
      this.indexList.splice(index, 1);
    },
    nextStepsFun() {
      let eventsInfo = {
        pointLevelIdList: [],
        selectedIdOptions: [],
        indexList: [],
        eventInfo: {
          sxmc: "",
          dayTimes: 1,
          ksWeekTimes: 1,
          id: "",
        },
      };
      if (!this.form.sxmc) {
        this.$message({
          type: "error",
          message: "请输入事项名称",
        });
        return;
      }
      if (!this.indexList.length) {
        this.$message({
          type: 'error',
          message: '请输入任务指标'
        })
        return;
      }
      eventsInfo.eventInfo = {
        sxmc: this.form.sxmc,
      };
      eventsInfo.indexList = this.indexList;
      this.$emit("updateEventsData", eventsInfo);
    },
    // 事项类型
    async selListFun() {
      const res = await selList({
        sxlx: "",
      });
      this.typeList = res.data.data || [];
      if (this.isEmergency) {
        this.typeList = this.typeList.filter((item) => {
          return item.superFlag == 1;
        });
      } else {
        this.typeList = this.typeList.filter((item) => {
          return item.superFlag != 1;
        });
      }
    },
    // 责任人类型
    async dictItemRootFun() {
      const res = await dictItemRoot({
        dictType: "GH_ZRRLX",
        data: true,
        page: 1,
        size: 9999,
        pid: -1,
      });
      this.zrrlxOptions = res.data.data.dataList || [];
    },

    // 分页查询
    async eventPageFun() {
      let params = {
        sxmc: this.searform.sxmc,
        sfyjsx: this.searform.sfyjsx,
        zrrlx: this.searform.zrrlx,
        ghEventTypeId: this.searform.ghEventTypeId,
        page: 1,
        size: 99999,
        sfFlag: this.isEmergency,
      };
      const res = await eventPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records ? res.data.data.records : [];
      }
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped lang="less">
@import "~@/components/less.less";
.events {
  height: 100%;
  width: 100%;
  // overflow: auto;
  .table-list {
    height: calc(100% - 70px);
    width: 100%;
    position: relative;
  }
  .index-list {
    height: calc(100% - 270px);
    width: 100%;
    .title {
      display: flex;
      align-items: center;
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 18px;
      color: #494c4f;
    }
    .index {
      height: calc(100% - 40px);
      width: 100%;
      overflow: auto;
      .index-item {
        width: 100%;
        background: #f7faff;
        border-radius: 4px;
        padding: 16px;
        margin-bottom: 16px;
        cursor: pointer;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 18px;
        color: #494c4f;
        .edit-btns {
          margin-top: 6px;
          display: flex;
        }
      }
      .index-item.active {
        background: #f7faff url("~@/assets/image/zbbg.png") right center no-repeat;
        background-size: 272px 100%;
        border-radius: 4px;
        border: 1px solid #0090ff;
      }
    }
    .empty {
      height: calc(100% - 40px);
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #494c4f;
      img {
        height: 126px;
      }
      .btns {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 13px;
        color: #92979c;
        margin-top: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/task/customTask/components/events.vue